/**
 * 生態商城側欄 menuId（Overseas patch 168）
 * @see scripts/mysql/menu_tree_ssot/ecosystem_mall_group.json
 */
export const ECOSYSTEM_MALL_MENU_IDS = {
  group: 990420,
  topology: 990421,
  catalog: 990422,
  synergyEdges: 990423,
  intents: 990424,
  vendors: 990425,
  mediaBilling: 990426,
  productSpecs: 990427,
  productionLines: 990428,
  search: 990429,
  mediaHub: 990430,
  productKnowledge: 990434,
  trialSim: 990435,
  businessPlans: 990436
}

export default ECOSYSTEM_MALL_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/ecosystemMall.js